import React, { useEffect, useState } from 'react'

import { func, string } from 'prop-types'

let AuthModal = null
let signInModalImportPromise = null

export const importAuthModal = () => {
  if (!signInModalImportPromise) {
    signInModalImportPromise = import(
      /* webpackChunkName: "auth-modal" */
      './AuthModal'
    ).then((mod) => { AuthModal = mod.default })
  }
  return signInModalImportPromise
}

function LazyAuthModal({ mode, step = undefined, onClose }) {
  const [isLoaded, setIsLoaded] = useState(() => !!AuthModal)

  useEffect(() => {
    if (!AuthModal) {
      importAuthModal().then(() => setIsLoaded(true))
    }
  }, [])

  if (!isLoaded || !AuthModal) return null
  return <AuthModal mode={mode} initialStep={step} onClose={onClose} />
}

LazyAuthModal.propTypes = {
  mode: string.isRequired,
  step: string,
  onClose: func.isRequired,
}

export default LazyAuthModal
